import React from "react"
import { Spacer, CmsImage } from "@bw/bits"
import * as Icons from "@bw/icons"
import styled from "styled-components"

const StyledSocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  background: transparent;
  font-size: 12px;
  font-weight: 400;
  line-height: 135.5%;
  color: #04062c;
  opacity: 1;
  transition: all 0.3s ease-in-out;
`

const SocialMedia = styled.div`
  padding: 5px;
  border-radius: 50%;
  background: var(--brand-brown);
  border: 2px solid var(--light-grey);
  transition:
    transform 0.3s ease-in-out,
    background 0.3s ease-in-out;

  &:hover {
    transform: scale(1.2);
    opacity: 1 !important;

    &.instagram {
      background: #d0126d;
      > * {
        fill: #fff;
      }
    }
    &.facebook {
      background: #2a528d;
    }
    &.youtube {
      background: #ae0d0d;
    }
    &.twitter {
      background: #1d9bf0;
    }
    &.tiktok {
      background: #8c44f7;
    }
    &.linkedin {
      background: #0a66c2;
    }
  }
`

const Socials = ({ networks }) => {
  if (!networks) {
    return null
  }

  return (
    <Spacer direction="row" gap="xsmall">
      {networks &&
        networks.map((network, i) => {
          const iconName =
            network.networkType.value.charAt(0).toUpperCase() +
            network.networkType.value.slice(1).toLowerCase()

          let icon

          if (iconName === "Other") {
            if (network.networkIcon) {
              icon = <CmsImage src={network.networkIcon.url} alt="" />
            } else {
              icon = (
                <Icons.Website fillColor="#fff" width="15px" height="15px" />
              )
            }
          } else {
            let Icon =
              typeof Icons[iconName] !== "undefined" ? Icons[iconName] : null
            icon = <Icon fillColor="#fff" width="15px" height="15px" />
          }

          return (
            <StyledSocialLink
              key={i}
              href={network.networkUrl}
              rel="noreferrer nofollow"
              target="_blank"
            >
              <SocialMedia className={network.networkType.value}>
                {icon}
              </SocialMedia>
            </StyledSocialLink>
          )
        })}
    </Spacer>
  )
}

export { Socials }
